import React from 'react';

/** 시안이 아직 없는 Ops 화면 — 메뉴 자리만 잡아 둔다 */
const Placeholder = ({ title, desc }) => (
  <div className='flex flex-col gap-6'>
    <h1 className='text-[28px] font-medium leading-[120%] tracking-[-0.01em] text-text-primary'>
      {title}
    </h1>
    <div className='rounded-2xl border border-dashed border-green-deep03/20 bg-grayscale-gray00 px-6 py-16 text-center'>
      <p className='text-[15px] font-medium text-text-primary'>Coming soon</p>
      <p className='mt-1 text-[14px] text-text-secondary'>{desc}</p>
    </div>
  </div>
);

export const OpsExport = () => (
  <Placeholder title='Export' desc='Download project data after it ends.' />
);
